import React, { useState } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../iconify/Iconify';

SlideIconButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.any,
  floatLeft: PropTypes.bool
}

export default function SlideIconButton ({ text, onClick, icon = null, floatLeft = false }) {
  const [isHovering, setIsHovering] = useState(false);

  return <Button
    variant="text"
    onMouseEnter={() => setIsHovering(true)}
    onMouseLeave={() => setIsHovering(false)}
    onClick={onClick}
    sx={{
      minHeight: 0, minWidth: 0, pl: 0, pr: isHovering ? 1 : 0, mr: isHovering ? 1 : 0, color: '#454F5B', fontWeight: "bold",
      ...(floatLeft ? { position: "absolute", left: 0, alignSelf: "center" } : {})
    }}
  >
    {icon ? typeof icon === "string" ? <Iconify icon={icon} width={24} height={24} /> : icon : ""}
    <Collapse orientation="horizontal" in={isHovering} sx={{ display: isHovering ? undefined : "none" }} collapsedSize={0} >
      <Box sx={{ overflow: "hidden", whiteSpace: 'nowrap' }}>
        {text}
      </Box>
    </Collapse>
  </Button>;
};